import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const ItemLoadingHolder = () => {
  return (
    <div className="py-20 bg-gradient-to-br from-indigo-50 to-white min-h-[400px]">
      <div className="container max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
        {/* Card principal */}
        <div className="md:col-span-2 bg-white rounded-2xl shadow-lg p-8 flex flex-col gap-4">
          <Skeleton height={40} width="50%" className="mb-4" />
          <Skeleton height={80} className="mb-2" />
          <Skeleton height={50} width="60%" className="mb-2" />
          <Skeleton height={50} width="90%" className="mb-2" />
          <Skeleton height={20} width="40%" className="mb-2" />
        </div>
        {/* Card secundar */}
        <div className="flex flex-col gap-8">
          <div className="bg-white rounded-2xl shadow-lg p-8">
            <Skeleton height={30} width="70%" className="mb-4" />
            <Skeleton height={36} className="mb-2" />
            <Skeleton height={16} width="90%" className="mb-2" />
            <Skeleton height={12} width="60%" className="mb-2" />
          </div>
          <div className="bg-white rounded-2xl shadow-lg p-8">
            <Skeleton height={30} width="70%" className="mb-4" />
            <Skeleton height={16} width="90%" className="mb-2" />
            <Skeleton height={12} width="60%" className="mb-2" />
          </div>
          <div className="bg-white rounded-2xl shadow-lg p-8">
            <Skeleton height={30} width="70%" className="mb-4" />
            <Skeleton height={36} />
          </div>
          <div className="bg-white rounded-2xl shadow-lg p-8">
            <Skeleton height={30} width="50%" className="mb-4" />
            <Skeleton height={50} />
          </div>
        </div>
      </div>
      {/* Skeleton pentru listă */}
      <div className="container max-w-5xl mx-auto mt-10 grid grid-cols-1 md:grid-cols-2 gap-6">
        {[...Array(2)].map((_, idx) => (
          <div
            key={idx}
            className="bg-white rounded-2xl shadow-lg p-8 flex flex-col gap-2"
          >
            <Skeleton height={30} width="50%" className="mb-4" />
            {[...Array(7)].map((__, i) => (
              <Skeleton key={i} height={12} width="100%" className="mb-2" />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ItemLoadingHolder;
